import Alpine from '@alpinejs/csp';

export default () => ({
  get formattedTime() {
    const timestamp = Alpine.store('serverTimestamp');
    if (!timestamp) {
      return '';
    }
    const date = new Date(timestamp);
    const locale = document.documentElement.lang || 'en';
    const formattedDate = new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'Europe/Amsterdam',
    }).format(date);
    const formattedTime = new Intl.DateTimeFormat(locale, {
      hour: 'numeric',
      minute: '2-digit',
      timeZone: 'Europe/Amsterdam',
    }).format(date);
    return `${formattedDate} ${formattedTime}`;
  },
});
